// **** import modules ****
import $ from "jquery";

// local modules
import app, { u_ } from "@@assets/scripts/app";
import vuwer from "@@assets/scripts/vuwer";
import loadGoogleCSE from "@@assets/scripts/loadGoogleCSE";


// **** process ****
vuwer.add("siteHeader", {
	selector: "#site_header",
	
	onReady($self) {
		if(!$self) {
			return false;
		}
		
		const $nav = $self.children(".site-nav");
		if($nav.length) {
			$nav.find("a").each((i, elm) => {
				if(elm.href === app.URL) {
					$(elm).addClass("is-current");
				}
			});
			
			const position = $nav.css("position");
			if("absolute_fixed".indexOf(position) >= 0) {
				vuwer.get("body").smoothScrollBuffer += $self.outerHeight(true);
			}
			
			this.setProp({ $nav });
		}
		
		// [google search engine]
		if(	u_.isObject(app.config.google) &&
				u_.isObject(app.config.google.cse) &&
				app.config.google.cse.searchID
		) {
			this.loadGoogleCSE(app.config.google.cse.searchID);
		}
	},
	
	loadGoogleCSE(searchID) {
		if(!searchID) {
			return false;
		}
		
		loadGoogleCSE(searchID, {
			// 埋め込み先のID（未指定の場合はbody直下の先頭に生成されます）
			targetID: "gcse_target",
			// テキストボックスのクラス
			textboxClass: "gcse-input gcse-textbox",
			// 検索実行ボタンのクラス
			submitClass: "gcse-input gcse-submit hoverTarget",
			// 検索ボタンのテキスト（未指定の場合は"検索"）
			submitValue: "&#xe8b6;"
		});
	}
});
